import {debounce} from 'throttle-debounce';
import Observer from 'common/scripts/observer';
import {Utils} from 'common/scripts/utils';

const observer = new Observer();

class ThemeBlocks {
    constructor() {
        this.blocks = [];
        this.theme = '';
        this.currentTheme = 'gray';
        this.pageTheme = 'gray';
        this.themes = {
            default    : '',
            white      : 'header_theme_white',
            gray       : 'header_theme_gray',
            transparent: 'header_theme_transparent'
        };
        this.elementTopPosition = null;
        this.header = null;
    }

    init(options = {}) {
        this.blocks = options.themeBlocks || Array.from(document.querySelectorAll('.j-theme-block'));
        this.header = options.header || document.querySelector('.j-header__base') || null;

        if (!this.header) {
            return;
        }

        this.pageThemeEl = document.querySelector('.j-theme-main');
        this.pageTheme = this.pageThemeEl ? this.pageThemeEl.dataset.theme || this.pageTheme : this.pageTheme;
        this.headerHeight = this.header.offsetHeight;
        this.offset = Utils.getScrollTop() > 0 ? this.headerHeight : -this.headerHeight;

        this._subscribes();
        this._bindEvents();
    }

    _subscribes() {
        observer.subscribe('changeScrollDirection', (direction) => {
            this.offset = direction === 'up' ? this.headerHeight : -this.headerHeight;
        });
    }

    _bindEvents() {
        $(document).ready(() => {
            this._checkState();
        });

        window.addEventListener('scroll', debounce(6, this._checkState.bind(this)));

        const events = ['resize', 'orientationchange'];

        events.forEach((event) => {
            window.addEventListener(event, () => {
                this.headerHeight = this.header.offsetHeight;
            });
        });
    }

    _checkState() {
        let foundBlock = false;

        this.blocks.forEach((element) => {
            const rect = element.getBoundingClientRect();
            const breadCrumbs = document.querySelector('.j-grid-breadcrumbs');
            const breadCrumbsHeight = breadCrumbs ? breadCrumbs.offsetHeight : 0;

            if (rect.top <= this.headerHeight + breadCrumbsHeight && rect.bottom >= this.headerHeight) {
                foundBlock = true;
                this.currentTheme = this.getBreakTheme(element);
            }
        });

        if (!foundBlock) {
            this.currentTheme = this.pageTheme;
        }

        if (this.currentTheme !== this.theme) {
            this.theme = this.currentTheme;
            observer.publish('changeHeaderTheme', this.themes[this.theme]);
        }
    }

    getBreakTheme(element) {
        const themes = {};
        let currentTheme = element.dataset.theme;
        let prevTheme = currentTheme;

        for (const key in element.dataset) {
            if (Object.prototype.hasOwnProperty.call(element.dataset, key)) {
                const breakPoint = key.split('-');

                themes[breakPoint[1] || 0] = element.dataset[key];
            }
        }

        for (const key in themes) {
            if (Object.prototype.hasOwnProperty.call(themes, key)) {
                currentTheme = window.innerWidth >= key ? themes[key] : prevTheme;
                prevTheme = currentTheme;
            }
        }

        return currentTheme;
    }
}

export default ThemeBlocks;
